
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, offersModule } from '@/store/modules/store-accessor'

@Component
export default class DeleteOfferLineItemModal extends Vue {
  @Prop()
  payload!: Record<string, any>;

  isDeletingOfferItem = false;

  async hideModal () {
    commonModule.hideModal();
  }

  async mounted() {
    commonModule.initSnackbar({});
  }

  async doDeleteOfferLineItem() {
    this.isDeletingOfferItem = true;

    try {
      await offersModule.deleteOfferLineItem(this.payload.data);
      this.hideModal();
    } finally {
      this.isDeletingOfferItem = false;
    }
  }
};
